import _slicedToArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.filter.js";
import vObjectFit from 'v-object-fit';
import Vue from 'vue';
import { store } from '@/store';
/**
 * Directive for adding a `data-fib-automation` attribute with a specified value for all environments
 * except production.
 *
 * The generated attributes *should only be used by test automation code*.
 *
 * Usage:
 *  v-fib-automation:name="value"     => data-fib-automation-name="123"
 *  v-fib-automation="'name' + value" => data-fib-automation-name="123"
 *  v-fib-automation="value"          => data-fib-automation="123"
 *  v-fib-automation="{ a: 1, b:2 }"  => data-fib-automation-a="1" data-fib-automation-b="2"
 *
 * Examples:
 *  <div v-fib-automation:question="value" />
 *    =>
 *      <div data-fib-automation-question="123" />
 *
 *  <div v-fib-automation="{ type: 'questions', id: 1 }" />
 *    =>
 *      <div data-fib-automation-type="questions" data-fib-automation-id="1" />
 *
 * The usage examples above assume `value` is a Vue data variable equal to 123.
 */

Vue.directive('fib-automation', {
  bind: function bind(el, binding) {
    if (!store.getters['config/automationEnabled']) {
      return;
    } // Generate the lookup containing attributes to generate:


    var attrs = {};

    if (binding.arg) {
      var _binding$value;

      attrs[binding.arg] = (_binding$value = binding.value) !== null && _binding$value !== void 0 ? _binding$value : '';
    } else if (_typeof(binding.value) === 'object' && binding.value !== null) {
      attrs = binding.value;
    } // Set the attributes on the element.


    for (var _i = 0, _Object$entries = Object.entries(attrs); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      el.setAttribute( // Prefix to avoid name clashes and to make these attributes easy to find.
      ['data-fib-automation', key].filter(Boolean).join('-'), value !== null && value !== void 0 ? value : '');
    }
  }
});
Vue.directive('object-fit', vObjectFit);